<template>
<div class="m-common">
    <div class="common">
        <div v-if="baikeLists">
            <div class="control-height">
                <nav class="down-pull">
                <div class="pull pull1">
                    <div class="title">{{pull1Current.value}}</div>
                    <ul>
                        <li @click="changPull1(item)" v-for="(item,index) in pull1" :key="index">{{item.value}}</li>
                    </ul>
                    <i></i>
                </div>
                <div class="pull pull2">  
                    <div class="title">{{pull2Current.value}}</div>
                    <ul>
                        <li @click="changPull2(item)" v-for="(item,index) in pull2" :key="index">{{item.value}}</li>
                    </ul>
                    <i></i>
                </div>
            </nav>
            <article>
                <baike :knowledge=knowledge v-if="knowledge && pageNo === 1"></baike>
                <div class="baike-wrap">
                    <div class="baike-item" v-for="(list,index) in baikeLists" :key="index">
                        <strong><a :href="`//baike.pcauto.com.cn/${list.id}.html`" target="_blank" v-html="list.title" @click="countAd(4451)"></a></strong>
                        <a :href="`//baike.pcauto.com.cn/${list.id}.html`" class="docLink" target="_blank">
                            <div class="doc">{{list.content}}</div>
                        </a>
                        <div class="paragraphInfo">
                            <span v-if="list.clusterList && list.clusterList.length > 0"><i>频道：</i><a :href="`//baike.pcauto.com.cn/cl${cluster.id}/`" target="_blank" :title="cluster.value" v-for="(cluster,index) in list.clusterList" :key="index" @click="countAd(4452)">{{cluster.value}}</a></span>
                            <span v-if="list.tagsList && list.tagsList.length > 0"><i>标签词：</i><a :href="`//baike.pcauto.com.cn/lb${tag.id}/`" target="_blank" :title="tag.value" v-for="(tag,index) in list.tagsList" :key="index" @click="countAd(4453)">{{tag.value}}</a></span>
                        </div>
                    </div>
                </div>
            </article>
            </div>
            <paging :totalPages=totalPages @reqData=reqBaike></paging>
            <search-box :id="2"></search-box>
        </div>
        <error-acrticle v-else :id="4454"></error-acrticle>
    </div>
    <common-side v-if="baikeLists" :propsOtherBaike=othersBaike></common-side>                
</div>
</template>

<script>
import Baike from '../../global/Baike.vue'
import ErrorAcrticle from '../../global/ErrorAcrticle.vue'
import CommonSide from '../../sides/Common'

    export default {
  components: { Baike, ErrorAcrticle,CommonSide },
        name: 'Common',
        data() {
            return {
                pull1Current: {value: '最相关', param:'', id: 0}, //第一个下拉框的当前列
                pull2Current: {value: '全部', param:'', id: 0}, //第二个下拉框的当前列
                pull1: [
                    {value: '最相关', param:'', id: 1},
                    {value: '最热门', param:'access', id: 2},
                
                ],
                pull2: [],
                totalPages: 0, //总页数
                knowledge: null, //百科头部信息
                baikeLists: [], //百科每列数据
                othersBaike: [], //百科右侧豆腐块可能推荐
                /* 
                * 请求参数
                */
               sort: '', //排序
               pageNo: 1, //页数
               clusterQuery: '', //类型参数
               enableHomonym: true, //是否使用同音词
            }
        },
        methods: {
            changPull1(item) {
                this.countAd(4280)
                if(item.value === this.pull1Current.value) return
                this.pull1Current = item
                this.sort = item.param
                this.reqBaike(this.pageNo)
            },
            changPull2(item) {
                this.countAd(4281   )
                if(item.value === this.pull2Current.value) return
                this.pull2Current = item
                this.clusterQuery = item.param
                this.reqBaike(this.pageNo)
            },
            async reqBaike(pageNo = 1) {
                try {
                    const res = await this.fetBaike({
                        q:this.$global.q,
                        sort:this.sort,
                        pageNo,
                        clusterQuery:this.clusterQuery,
                        enableHomonym:this.enableHomonym
                    })
                    this.baikeLists = res.result
                    this.totalPages = res.totalPage
                    this.knowledge = res.knowledge
                    this.$global.qType = res.type
                    this.pageNo = pageNo
                    if(res.knowledge) {
                        this.othersBaike = res.knowledge.othersBaike
                    }
                    if(res) {
                        document.body.scrollTop = document.documentElement.scrollTop = 0
                    }                    
                    if(res.clusterResult) {
                        const clusterResult = res.clusterResult.map(v => {
                            return {value:v.clu,param:`${v.id}/${v.clu}`,id:v.clu}
                        })
                        this.pull2 = [{value: '全部', param:'', id: 0}]
                        this.pull2.push(...clusterResult)
                    }
                } catch (error) {
                    console.error(error)
                }
            }
        },
        mounted() {
            this.countColumnAd(8453)
            this.reqBaike()
            // this.$EventBus.$on(`${this.$global.tab.title}`,() => {this.reqBaike()})
        }
    }
</script>

<style lang="scss" scoped>
.m-common {
    display: flex;
    justify-content: space-between;
    width: 1000px;
}
.common {
    width: 620px;
    .down-pull {
        display: flex;
        color: #225599;
        border-bottom: 1px solid #eeeeee;
        height: 46px;
        align-items: center;
        .pull {
            height: 28px;
            line-height: 28px;
            position: relative;
            margin-left: 10px;
            box-sizing: border-box;
                i {
                    display: block;
                    width: 7px;
                    height: 4px;
                    position: absolute;
                    right: 8px;
                    top: 11px;
                    overflow: hidden;
                    background-image: url($imageURL);
                    background-position: -8px -29px;
                }
            .title {
                width: 80px ;
                border: 1px solid transparent;
                padding-left: 6px;
                cursor: pointer;
                background-color: #fcfcfc;
            }
            ul {
                position: absolute;
                top: 28px;
                left: 0;
                display: none; 
                background-color: #fcfcfc; 
                width: 80px;
                cursor: pointer;
                color: #777777;
            }
            &.pull1 {
                &:hover {
                    ul{
                        display: block;
                        border: 1px solid #e5e5e5;
                    }
                    i {
                        transform: rotate(180deg);
                    }
                }
            }
            &.pull2 {
                &:hover {
                    ul{
                        display: block;
                        border: 1px solid #e5e5e5;
                    }
                    i {
                        transform: rotate(180deg);
                    }
                }
            }
            &.pull3 {
                &:hover {
                    ul{
                        display: block;
                        border: 1px solid #e5e5e5;
                    }
                    i {
                        transform: rotate(180deg);
                    }
                }
            }
            li {
                width: 100%;
                padding-left: 6px;
                box-sizing: border-box;
                &:hover {
                    background-color: #f3f3f3;
                    color: #225599;
                }
            }
            &:first-of-type {
                margin-left: 0;
            }
        }
    }
    .baike-wrap {
        .baike-item {
            font-size: 12px;
            margin-top: 20px;
            strong {
                font-weight: normal;
                font-size: 16px;
                line-height: 32px;
                a {
                    text-decoration: underline;
                    color: #225599;
                   ::v-deep em {
                        color: #cc0000;
                        text-decoration: underline;
                        font-style: normal;
                    }
                }
            }
            .docLink {
                text-decoration: none;
                display: block;
                .doc {
                    color: #333333;
                    line-height: 22px;
                    overflow: hidden;
                    position: relative;
                    em {
                        color: #cc0000;
                        font-style: normal;
                    }
                }
            }
            .paragraphInfo {
                span {
                    width: 120px;
                    display: inline-block;
                    color: #333333;
                    height: 20px;
                    overflow: hidden;
                    word-break: break-all;
                    word-wrap: break-word;
                    margin-right: 5px;
                    i {
                        color: #777777;
                        font-style: normal;
                    }
                    a {
                        color: #333333;
                    }
                }
            }
        }
    }
}
</style>